import React, { useRef } from "react";

import Stack from "react-bootstrap/Stack";
import Form from "react-bootstrap/Form";

import { DateRangeInput } from "./DateRangeInput";

export default function DateRangeInputWrapper({
  label,
  id,
  size,
  styles,
  startDate,
  endDate,
  onChange,
  minDate,
  maxDate,
  isReadOnly = false,
  error,
}) {
  const dateRef = useRef();

  return (
    <Form.Group>
      <div
        className={`date-picker-card day-picker-card ${size ? `date-picker-card-${size}` : ""} ${styles || ""}`}
        ref={dateRef}
      >
        <Stack>
          {label && (
            <Form.Label htmlFor={id} className={`${error ? "error" : ""}`}>
              {label}
            </Form.Label>
          )}
          <DateRangeInput
            id={id}
            startDate={startDate}
            endDate={endDate}
            onChange={onChange}
            minDate={minDate}
            maxDate={maxDate}
            reference={dateRef}
            isReadOnly={isReadOnly}
          />
        </Stack>
      </div>
    </Form.Group>
  );
}
